import LockIcon from '@jetbrains/icons/lock.svg'
import Avatar, {Size as AvatarSize} from '@jetbrains/ring-ui/components/avatar/avatar'

import type {RepositoryDetailsItem, RepositoryListItem} from './RepositoryList.types'

import styles from './RepositoryList.css'

export const getRepositoryItem = ({
  login,
  avatarUrl,
  repositoryName,
  repositoryUrl,
  defaultBranch,
  isPrivate,
}: RepositoryDetailsItem): RepositoryListItem => ({
  key: `${login}_${repositoryName}`,
  label: (
    <span className={styles.repositoryItem}>
      {repositoryName}
      {isPrivate && <LockIcon className={styles.repositoryItemPrivate} />}
      <span className={styles.repositoryItemLogin}>{login}</span>
    </span>
  ),
  repositoryName,
  repositoryUrl,
  defaultBranch,
  leftNodes: (
    <Avatar
      className={styles.image}
      size={AvatarSize.Size20}
      alt={login}
      title={login}
      url={avatarUrl}
      username={login}
    />
  ),
  rightNodes: <span className={styles.labelCreate}>{'Create'}</span>,
  className: styles.item,
  hoverClassName: styles.itemHover,
  level: 6, // 2 levels margin + 3 levels are reserved for the image + 1 level margin
  isPrivate,
})
